import { colors } from './colors'

export const tokens = {
  colors,
}
